(function(){
  if (window.__ctsWish) return; window.__ctsWish = true;
  var KEY = 'cts-wishlist';
  function get(){ try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e){ return []; } }
  function set(l){ try { localStorage.setItem(KEY, JSON.stringify(l)); } catch(e){} }
  window.ctsWishlist = { get: get, set: function(l){ set(l); paint(); emit(l); } };
  function emit(l){ document.dispatchEvent(new CustomEvent('wishlist:change', { detail: l })); }
  function paint(){
    var l = get();
    document.querySelectorAll('[data-wish]').forEach(function(b){
      var on = l.indexOf(b.getAttribute('data-wish')) > -1;
      if (b.getAttribute('aria-pressed') !== (on ? 'true' : 'false')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lab = (on ? 'Remove ' : 'Add ') + (b.getAttribute('data-title') || 'item') + (on ? ' from wishlist' : ' to wishlist');
      if (b.getAttribute('aria-label') !== lab) b.setAttribute('aria-label', lab);
    });
    document.querySelectorAll('[data-wish-count]').forEach(function(c){ var t = String(l.length); if (c.textContent !== t) c.textContent = t; c.hidden = l.length === 0; });
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-wish'), l = get(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.push(h);
    set(l); paint(); emit(l);
    b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
  }, true);
  window.addEventListener('storage', function(e){ if (e.key === KEY) { paint(); emit(get()); } });
  document.addEventListener('shopify:section:load', paint);
  var q = false;
  new MutationObserver(function(m){ if (q) return; for (var k = 0; k < m.length; k++) if (m[k].addedNodes.length) { q = true; requestAnimationFrame(function(){ q = false; paint(); }); break; } }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();

  /* ---------- Header wishlist dropdown ---------- */
  var css = '.wd{position:fixed;z-index:60;width:min(340px,calc(100vw - 24px));background:var(--color-bg,#f3f2f2);color:var(--color-text,#201e1d);border:2px solid var(--color-text,#201e1d);box-shadow:0 12px 32px rgba(0,0,0,.14);padding:12px;display:flex;flex-direction:column;gap:12px;opacity:0;transform:translateY(-6px);transition:opacity .18s ease,transform .18s ease;pointer-events:none}'
    + '.wd.is-open{opacity:1;transform:none;pointer-events:auto}'
    + '.wd__list{display:flex;flex-direction:column;gap:10px;max-height:300px;overflow:auto;margin:0;padding:0;list-style:none}'
    + '.wd__item{display:grid;grid-template-columns:56px minmax(0,1fr) auto;gap:12px;align-items:center}'
    + '.wd__img{width:56px;height:56px;object-fit:cover;display:block;background:var(--color-surface,#eae9e9)}'
    + '.wd__t{font-size:15px;font-weight:600;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:inherit;text-decoration:none;display:block}.wd__t:hover{color:var(--color-accent,#ec3013)}'
    + '.wd__p{font-size:13px;color:var(--color-neutral-700,#5d5856);margin-top:4px}'
    + '.wd__x{border:0;background:none;cursor:pointer;color:inherit;font-size:20px;line-height:1;width:32px;height:32px;display:grid;place-items:center}.wd__x:hover{color:var(--color-accent,#ec3013)}'
    + '.wd__btn{display:flex;justify-content:center;align-items:center;min-height:48px;background:var(--color-text,#201e1d);color:var(--color-bg,#f3f2f2);font-weight:600;font-size:15px;text-decoration:none}.wd__btn:hover{background:var(--color-accent,#ec3013);color:var(--color-bg,#f3f2f2)}'
    + '.wd__empty{font-size:14px;margin:4px 0;color:var(--color-neutral-700,#5d5856)}'
    + '.wd__sk{height:56px;background:var(--color-surface,#eae9e9)}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var cache = {}, box = null, trigger = null;
  var money = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
  var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  function url(p){ return (root + '/' + p).replace(/\/+/g, '/'); }
  function esc(t){ return String(t == null ? '' : t).replace(/[&<>"]/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fetchP(h){
    if (cache[h]) return Promise.resolve(cache[h]);
    return fetch(url('products/' + h + '.js')).then(function(r){ return r.ok ? r.json() : null; }).then(function(p){ if (p) cache[h] = p; return p; }).catch(function(){ return null; });
  }
  function place(){
    if (!box || !trigger) return;
    var r = trigger.getBoundingClientRect(), w = box.offsetWidth;
    box.style.top = Math.round(r.bottom + 10) + 'px';
    box.style.left = Math.round(Math.max(12, Math.min(window.innerWidth - w - 12, r.right - w))) + 'px';
  }
  function render(){
    if (!box) return;
    var l = get();
    var allUrl = url('pages/wishlist');
    if (!l.length) { box.innerHTML = '<p class="wd__empty">Your wishlist is empty. Tap the heart on any print to save it here.</p><a class="wd__btn" href="' + url('collections/all') + '">Browse prints</a>'; place(); return; }
    box.innerHTML = '<ul class="wd__list">' + l.map(function(){ return '<li class="wd__sk"></li>'; }).join('') + '</ul><a class="wd__btn" href="' + allUrl + '">View All (' + l.length + ')</a>';
    place();
    Promise.all(l.map(fetchP)).then(function(ps){
      if (!box) return;
      var items = ps.map(function(p, i){
        if (!p) return '';
        var img = p.featured_image ? (p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2').split('?')[0] + '?width=160') : '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        return '<li class="wd__item">' + (img ? '<img class="wd__img" src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="wd__img"></span>') +
          '<div style="min-width:0"><a class="wd__t" href="' + esc(p.url || url('products/' + l[i])) + '">' + esc(p.title) + '</a><div class="wd__p">' + money.format(p.price / 100) + '</div></div>' +
          '<button type="button" class="wd__x" data-wd-remove="' + esc(l[i]) + '" aria-label="Remove ' + esc(p.title) + ' from wishlist">&times;</button></li>';
      }).join('');
      var list = box.querySelector('.wd__list'); if (list) list.innerHTML = items;
      place();
    });
  }
  function open(t){
    trigger = t;
    if (!box) { box = document.createElement('div'); box.className = 'wd'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-label', 'Wishlist'); document.body.appendChild(box); }
    render();
    requestAnimationFrame(function(){ box.classList.add('is-open'); });
    t.setAttribute('aria-expanded', 'true');
  }
  function close(){
    if (!box || !box.classList.contains('is-open')) return;
    box.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }
  function isOpen(){ return box && box.classList.contains('is-open'); }
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('.header__wish');
    if (t) { e.preventDefault(); e.stopPropagation(); if (isOpen() && trigger === t) close(); else open(t); return; }
    var rm = e.target.closest && e.target.closest('[data-wd-remove]');
    if (rm) { e.preventDefault(); e.stopPropagation(); var l = get(), i = l.indexOf(rm.getAttribute('data-wd-remove')); if (i > -1) { l.splice(i, 1); set(l); paint(); emit(l); } return; }
    if (isOpen() && !box.contains(e.target)) close();
  }, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
  window.addEventListener('resize', place);
  window.addEventListener('scroll', function(){ if (isOpen()) place(); }, { passive: true });
  document.addEventListener('wishlist:change', function(){ if (isOpen()) render(); });
})();
